import Toggle from "PFComponents/toggle/toggle";
import PropTypes from "prop-types";
import React from "react";
import { withTranslation } from "react-i18next";

import css from "./review_toggleable_section.scss";

const ReviewToggleableSection = ({
  style,
  children,
  disabled,
  handleToggle,
  collapsedTitle,
  fadeMode,
  t
}) => (
  <div className={css.root} style={style} data-qa-id="OnboardingPage.ReviewToggleableSection">
    {(disabled || fadeMode) && <div className={css.collapsedTitle}>{collapsedTitle}</div>}
    <div
      className={css.children}
      style={{
        transition: "opacity ease 200ms",
        display: disabled && !fadeMode ? "none" : "block",
        opacity: disabled ? 0.5 : 1
      }}
    >
      {children}
    </div>
    <div className={css.toggle}>
      <span>{t("displayInProfile")}</span>
      <Toggle checked={!disabled} onChange={handleToggle} />
    </div>
  </div>
);

ReviewToggleableSection.propTypes = {
  children: PropTypes.node.isRequired,
  collapsedTitle: PropTypes.string.isRequired,
  handleToggle: PropTypes.func.isRequired,

  disabled: PropTypes.bool,
  style: PropTypes.object,
  fadeMode: PropTypes.bool,
  t: PropTypes.func
};

export default withTranslation("onboarding")(ReviewToggleableSection);
